import { computed } from 'vue'
import { useMenuPermissions } from '@/composables/useMenuPermissions'

export interface SearchResultItem {
  type: 'module'
  label: string
  to: string
  group?: string
  icon?: string
}

export const useGlobalSearch = () => {
  const { visibleMenuItems } = useMenuPermissions()

  const iconFor = (path: string, label?: string) => {
    const p = (path || '').toLowerCase()
    const l = (label || '').toLowerCase()
    if (p.includes('dashboard') || l.includes('tableau')) return 'dashboard'
    if (p.includes('utilisateur') || p.includes('users')) return 'users'
    if (p.includes('employe')) return 'employees'
    if (p.includes('paie') || p.includes('payroll')) return 'payroll'
    if (p.includes('absence')) return 'absence'
    if (p.includes('presence') || p.includes('attendance')) return 'presence'
    if (p.includes('remuneration')) return 'remuneration'
    if (p.includes('notes-frais') || p.includes('expense')) return 'expense'
    if (p.includes('document')) return 'documents'
    if (p.includes('equipement')) return 'equipments'
    if (p.includes('syndicat') || p.includes('union')) return 'unions'
    if (p.includes('rapport') || p.includes('report')) return 'reports'
    if (p.includes('configuration') || p.includes('settings') || p.includes('system')) return 'settings'
    if (p.includes('calendar')) return 'calendar'
    if (p.includes('task')) return 'tasks'
    if (p.includes('project')) return 'projects'
    if (p.includes('analytics')) return 'analytics'
    if (p.includes('workflow')) return 'workflow'
    if (p.includes('form')) return 'forms'
    if (p.includes('file')) return 'files'
    if (p.includes('audit')) return 'audit'
    if (p.includes('integration')) return 'integration'
    if (p.includes('training') || l.includes('formation')) return 'training'
    if (p.includes('evaluation')) return 'evaluation'
    if (p.includes('recruit') || p.includes('recrut')) return 'recruitment'
    if (p.includes('planning')) return 'planning'
    if (p.includes('leave') || p.includes('cong')) return 'leave'
    if (p.includes('medical')) return 'medical'
    if (p.includes('security')) return 'security'
    if (p.includes('budget')) return 'budget'
    return 'module'
  }

  const flattenedMenu = computed(() => {
    const items: SearchResultItem[] = []
    const walk = (arr: any[], parent?: string) => {
      arr.forEach((it) => {
        const label = it.label || it.title || ''
        const to = it.to || it.path || '/'
        items.push({ type: 'module', label, to, group: parent, icon: iconFor(to, label) })
        if (Array.isArray(it.children) && it.children.length) {
          walk(it.children, it.label || it.title)
        }
      })
    }
    walk(visibleMenuItems.value || [])
    return items
  })

  const search = (query: string, limit = 10): SearchResultItem[] => {
    const q = (query || '').trim().toLowerCase()
    if (!q) return []
    const results = flattenedMenu.value.filter(it => (it.label || '').toLowerCase().includes(q))
    return results.slice(0, limit)
  }

  return { search }
}


